import { motion } from "framer-motion";
import { BadgeCheck, MapPin } from "lucide-react";
import { CONSULTOR, waLink } from "../../data/site";
import { Reveal } from "./Reveal";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const ConsultantIntro = () => (
  <section id="sobre" data-testid="consultant-intro-section" className="bg-paper py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
      <Reveal className="lg:col-span-5">
        <motion.div
          animate={{ y: [0, -8, 0] }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
          className="relative mx-auto max-w-md"
        >
          <div className="absolute -bottom-4 -right-4 h-full w-full rounded-[2rem] border border-champagne/30" />
          <div className="relative overflow-hidden rounded-[2rem] shadow-xl shadow-black/40">
            <img
              src="/assets/leo-sobre.jpg"
              alt={`${CONSULTOR.name}, consultor de planos de saúde`}
              data-testid="intro-consultant-photo"
              className="aspect-[4/5] w-full object-cover object-top"
            />
          </div>
          <div className="absolute -left-4 top-8 rounded-2xl border border-white/10 bg-surface/95 px-5 py-3.5 shadow-lg backdrop-blur-xl sm:-left-8">
            <p className="font-display text-2xl font-semibold text-ink">
              {CONSULTOR.years}+ <span className="text-sm text-stone-500">anos</span>
            </p>
            <p className="text-[11px] font-medium text-stone-500">de experiência</p>
          </div>
        </motion.div>
      </Reveal>

      <div className="lg:col-span-7 lg:pl-8">
        <Reveal>
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.24em] text-champagne-dark">
            O consultor
          </p>
          <h2 className="mt-4 font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl lg:text-5xl">
            Prazer, eu sou <em className="italic text-champagne-dark">{CONSULTOR.name}.</em>
          </h2>
          <p className="mt-4 font-display text-xl font-medium text-ink/70">
            Consultor de planos de saúde há mais de {CONSULTOR.years} anos.
          </p>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-stone-400">
            Atuo na consultoria de planos de saúde para pessoas, dependentes e
            empresas, oferecendo atendimento personalizado, presencial ou virtual,
            e ajudando cada cliente a encontrar uma opção adequada ao seu perfil.
          </p>
        </Reveal>
        <Reveal delay={0.15} className="mt-8 flex flex-wrap items-center gap-3">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-surface px-4 py-2 text-xs font-semibold text-ink">
            <BadgeCheck className="h-4 w-4 text-champagne-dark" />
            Atendimento presencial ou virtual
          </span>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-surface px-4 py-2 text-xs font-semibold text-ink">
            <MapPin className="h-4 w-4 text-champagne-dark" />
            Brasília/DF e região
          </span>
        </Reveal>
        <Reveal delay={0.25} className="mt-9">
          <a
            href={waLink("Olá, Leomar! Gostaria de conversar sobre planos de saúde.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="intro-whatsapp-cta"
            className="group inline-flex items-center gap-3 rounded-full bg-brand px-7 py-4 text-sm font-bold text-white transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-brand-dark"
          >
            <WhatsAppIcon className="h-5 w-5 text-wa transition-transform duration-300 group-hover:rotate-6" />
            Falar comigo
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
